import {EntityFactory, Reducer, AsyncAction} from '@modifi/redux'
import {ProviderIdType} from '@modifi/enums'
import {
  getAuthenticatedThemisClient,
  PublicRegisteredCompanyDetailsView,
} from '@modifi/onboarding-api-clients'

const apiClient = getAuthenticatedThemisClient()

export type PublicRegisteredCompanyDetailsWithProviderId = PublicRegisteredCompanyDetailsView & {
  providerCompanyId: string
}

const {actions, selectors, reducer} = EntityFactory({
  actionNamePrefix: 'data/publicRegisteredCompany/selected',
  rootSelector: state => state?.data?.publicRegisteredCompanies?.selected,
  // @ts-expect-error redux package type error
  fetchRequest: (state, {countryCode, providerCompanyId, idType}) => {
    const body = {
      countryCode,
      providerCompanyId,
      idType: idType || ProviderIdType.PROVIDER_ID,
    }
    return apiClient.PublicRegisteredCompanies.byId({
      body,
    }).then(res => ({
      ...res.data(),
      providerCompanyId,
    }))
  },
})

export default reducer as Reducer

// selectors
export const selectPublicRegisteredCompany = selectors.selectEntity
export const selectPublicRegisteredCompanyIsLoading = selectors.selectIsLoading

// actions
export const aFetchPublicRegisteredCompany = (
  providerCompanyId: string,
  idType?: string
): AsyncAction => actions!.fetch({providerCompanyId, idType})
